import { useEffect, useState, useCallback } from 'react';
import { UsersApi } from '../../clients';

export const useGetFacilityUser = ({ id }) => {
  const [state, setState] = useState({
    user: null,
    loading: true,
    error: null,
  });

  const setPartialState = (updates) => {
    setState((prevState) => ({ ...prevState, ...updates }));
  };

  const fetchUser = useCallback(async () => {
    if (!id) {
      setPartialState({
        loading: false,
        error: 'User ID is required',
        user: null,
      });
      return;
    }

    setPartialState({
      loading: true,
      error: null,
    });

    try {
      const { data } = await UsersApi.getFacilityUser(id);
      setPartialState({
        user: data,
        loading: false,
        error: null,
      });
    } catch (error) {
      console.error('Error fetching facility user:', error);
      setPartialState({
        loading: false,
        error: 'Failed to load user details',
        user: null,
      });
    }
  }, [id]);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  const refetch = useCallback(() => {
    fetchUser();
  }, [fetchUser]);

  return {
    ...state,
    refetch,
  };
};
